import { useQuery } from '@tanstack/react-query';

import { fetchProductEngagement } from '../../services/productEngagement';

const RANGE_DAYS = 30;
const LIMIT = 5;

const formatPercent = (value: number) => `${(value * 100).toFixed(1)}%`;

export default function ProductEngagementCard() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['analytics', 'product-engagement', RANGE_DAYS, LIMIT],
    queryFn: () => fetchProductEngagement(RANGE_DAYS, LIMIT),
  });

  const topViewed = data?.topViewed ?? [];
  const topNoPurchase = data?.topNoPurchase ?? [];

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <p className="card-title">Ürün ilgisi</p>
          <p className="card-subtitle">
            Son {RANGE_DAYS} günde en çok görüntülenen ürünler ve henüz siparişe dönüşmeyen fırsatlar
          </p>
        </div>
        <button type="button" className="button ghost" onClick={() => refetch()}>
          Yenile
        </button>
      </div>

      {isError ? (
        <div className="empty-state">
          <strong>Ürün etkileşimleri yüklenemedi</strong>
          <p>{error instanceof Error ? error.message : 'Veri alınırken bir hata oluştu.'}</p>
        </div>
      ) : (
        <div className="two-column" style={{ gap: '16px' }}>
          <div>
            <h3>En çok görüntülenenler</h3>
            {isLoading ? (
              <p className="helper-text">Yükleniyor…</p>
            ) : topViewed.length === 0 ? (
              <p className="helper-text">Bu aralıkta etkileşim bulunamadı.</p>
            ) : (
              <table className="data-table compact">
                <thead>
                  <tr>
                    <th>Ürün</th>
                    <th>Görüntüleme</th>
                    <th>Sepete ekleme</th>
                    <th>Sipariş</th>
                    <th>Dönüşüm</th>
                  </tr>
                </thead>
                <tbody>
                  {topViewed.map((record) => (
                    <tr key={record.productId}>
                      <td>
                        <strong>{record.productName}</strong>
                        <p className="helper-text">{record.category ?? 'Genel'}</p>
                      </td>
                      <td>{record.viewCount}</td>
                      <td>{record.addToCartCount}</td>
                      <td>{record.orderCount}</td>
                      <td>{formatPercent(record.conversionRate)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div>
            <h3>Siparişe dönüşmeyenler</h3>
            {isLoading ? (
              <p className="helper-text">Yükleniyor…</p>
            ) : topNoPurchase.length === 0 ? (
              <p className="helper-text">Görüntülenen fakat sipariş edilmeyen ürün yok.</p>
            ) : (
              <table className="data-table compact">
                <thead>
                  <tr>
                    <th>Ürün</th>
                    <th>Görüntüleme</th>
                    <th>Sepete ekleme</th>
                  </tr>
                </thead>
                <tbody>
                  {topNoPurchase.map((record) => (
                    <tr key={record.productId}>
                      <td>
                        <strong>{record.productName}</strong>
                        <p className="helper-text">{record.category ?? 'Genel'}</p>
                      </td>
                      <td>{record.viewCount}</td>
                      <td>{record.addToCartCount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
